import React from 'react';
import moment from 'moment';
import { Typography, Card, Grid, CardContent, CardHeader } from '@material-ui/core';
import { MdSpace, SmSpace } from 'm2m.components';
import { ParticipanteResponse } from 'common/genericTypes';
import { addCpfCnpjMask, addTelefoneMask } from 'utils/mask';

interface Props {
  representantesLegais: ParticipanteResponse;
}

export const RepresentantesLegais: React.FC<Props> = (props) => {
  const { representantesLegais } = props;

  return (
    <>
      <MdSpace />
      <Grid container spacing={3}>
        {representantesLegais.representantesLegais?.map((_, i) => (
          <Grid item key={i} lg={4}>
            <Card variant="outlined">
              <CardHeader
                style={{ paddingBottom: 0 }}
                title={
                  <Typography
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    variant={'h3'}
                  >
                    {_.nome}
                  </Typography>
                }
              />
              <CardContent>
                <Grid container>
                  <Grid item md={6}>
                    <Typography variant={'body2'}>{'Perfil:'}</Typography>
                    <Typography variant={'body1'}>{_.tipo}</Typography>
                    <SmSpace />
                  </Grid>
                  <Grid item md={6}>
                    <Typography variant="body2">{'Email:'}</Typography>
                    <Typography variant="body1">{_.email}</Typography>
                    <SmSpace />
                  </Grid>
                  <Grid item md={6}>
                    <Typography variant={'body2'}>{'CPF:'}</Typography>
                    <Typography variant={'body1'}>{addCpfCnpjMask(_.cpf)}</Typography>
                  </Grid>
                  {_.cargo && (
                    <Grid item md={6}>
                      <Typography variant={'body2'}>{'Cargo:'}</Typography>
                      <Typography variant={'body1'}>{_.cargo}</Typography>
                      <SmSpace />
                    </Grid>
                  )}
                  {_.telefone && (
                    <Grid item md={6}>
                      <Typography variant={'body2'}>{'Telefone:'}</Typography>
                      <Typography variant={'body1'}>{addTelefoneMask(_.telefone)}</Typography>
                      <SmSpace />
                    </Grid>
                  )}
                  <Grid item md={6}>
                    <Typography variant={'body2'}>{'Outorga Total:'}</Typography>
                    <Typography variant={'body1'}>{_.outorgaTotal ? 'Sim' : 'Não'}</Typography>
                    <SmSpace />
                  </Grid>
                  {_.dataExpiracao && (
                    <Grid item md={6}>
                      <Typography variant={'body2'}>{'Data de Expiração:'}</Typography>
                      <Typography variant={'body1'}>
                        {moment(_.dataExpiracao as any).format('DD/MM/YYYY')}
                      </Typography>
                      <SmSpace />
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default RepresentantesLegais;
